import ApiProvider from 'context-store/api/ApiProvider';
import React from 'react';

const Providers: React.FC = ({ children }) => {
  return <ApiProvider>{children}</ApiProvider>;
};

export default Providers;
